<template>
  <div class="members_detail" v-if="user !== ''">
    <v-container>
      <div class="heading text-h4 pl-4">プロフィール</div>
      <v-row class="mt-2">
        <v-col cols="12" offset="1">
          <div class="text-h5">
            氏名：{{ prof.name_jp }} ({{ prof.name_en }})
          </div>
        </v-col>
      </v-row>

      <template v-if="prof.isTeacher">
        <v-row class="mt-2">
          <v-col cols="12" offset="1">
            <div class="text-h5">職名：{{ prof.jobTitle }}</div>
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row class="mt-2">
          <v-col cols="12" offset="1">
            <div class="text-h5">学年：{{ prof.grade }}</div>
          </v-col>
        </v-row>

        <v-row class="mt-2">
          <v-col cols="12" offset="1">
            <div class="text-h5">小グループ：{{ prof.group }}</div>
          </v-col>
        </v-row>

        <v-row class="mt-2">
          <v-col cols="12" offset="1">
            <div class="text-h5">研究テーマ：{{ prof.theme }}</div>
          </v-col>
        </v-row>
      </template>

      <div v-show="prof.isTeacher" class="heading text-h4 pl-4 mt-8">自己紹介</div>
      <v-row justify="center">
        <v-col class="my-4" cols="11">
          <div v-show="prof.isTeacher">{{ prof.introduce }}</div>
        </v-col>
      </v-row>

      <v-row class="mt-2">
          <v-col cols="10" offset="1" v-for="image in prof.images" :key="image">
              <v-img :src="image" eager></v-img>            
          </v-col>
        </v-row>

      <div class="heading text-h4 pl-4">関連リンク</div>
      <v-row class="mt-2">
        <v-col cols="12" offset="1" v-for="(link, index) in prof.links" :key="index">
          <div class="text-h5">
            <a :href="link.url" target="_blank">{{link.title}}</a>
          </div>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import profiles from "./data/profiles.js";

export default {
  name: "MembersDetail",
  data: () => ({
    user: "",
    prof: {},
  }),
  computed: {},
  mounted() {
    this.user = this.$route.params.user_name;
    this.prof = profiles[this.user];
  },
};
</script>


<style scoped>
.heading {
  border-bottom: 2px solid #000;
}
</style>